import { PriceBookItemTypes } from "@legacy/core/utils/enums"

import { Table } from "@organisms"

import { PRICEBOOK_ITEMS_ROUTES } from "@routes/pricebook-items"

export const ServicesTabs = () => (
    <Table.Tabs>
        <Table.Tab
            id="all_active"
            title="All Active"
            phase="active"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.service],
                ["is_active", "true"],
                ["ordering", "confirmed,description"],
            ]}
            isDefaultActiveTabForPhase={true}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
        <Table.Tab
            id="review"
            title="Review"
            phase="active"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.service],
                ["is_active", "true"],
                ["confirmed", "false"],
                ["ordering", "description"],
            ]}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
        <Table.Tab
            id="confirmed"
            title="Confirmed"
            phase="active"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.service],
                ["is_active", "true"],
                ["confirmed", "true"],
                ["ordering", "description"],
            ]}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
        <Table.Tab
            id="all_inactive"
            title="All Inactive"
            phase="inactive"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.service],
                ["is_active", "false"],
                ["ordering", "confirmed,description"],
            ]}
            isDefaultActiveTabForPhase={true}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
    </Table.Tabs>
)

export const PartsAndMaterialsTabs = () => (
    <Table.Tabs>
        <Table.Tab
            id="all_active"
            title="All Active"
            phase="active"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.part],
                ["is_active", "true"],
                ["ordering", "confirmed,description"],
            ]}
            isDefaultActiveTabForPhase={true}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
        <Table.Tab
            id="review"
            title="Review"
            phase="active"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.part],
                ["is_active", "true"],
                ["confirmed", "false"],
                ["ordering", "description"],
            ]}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
        <Table.Tab
            id="confirmed"
            title="Confirmed"
            phase="active"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.part],
                ["is_active", "true"],
                ["confirmed", "true"],
                ["ordering", "description"],
            ]}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
        <Table.Tab
            id="all_inactive"
            title="All Inactive"
            phase="inactive"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.part],
                ["is_active", "false"],
                ["ordering", "confirmed,description"],
            ]}
            isDefaultActiveTabForPhase={true}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
    </Table.Tabs>
)

export const MiscellaneousTabs = () => (
    <Table.Tabs>
        <Table.Tab
            id="all_active"
            title="All Active"
            phase="active"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.other],
                ["is_active", "true"],
                ["ordering", "confirmed,description"],
            ]}
            isDefaultActiveTabForPhase={true}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
        <Table.Tab
            id="review"
            title="Review"
            phase="active"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.other],
                ["is_active", "true"],
                ["confirmed", "false"],
                ["ordering", "description"],
            ]}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
        <Table.Tab
            id="confirmed"
            title="Confirmed"
            phase="active"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.other],
                ["is_active", "true"],
                ["confirmed", "true"],
                ["ordering", "description"],
            ]}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
        <Table.Tab
            id="all_inactive"
            title="All Inactive"
            phase="inactive"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.other],
                ["is_active", "false"],
                ["ordering", "confirmed,description"],
            ]}
            isDefaultActiveTabForPhase={true}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
    </Table.Tabs>
)

export const DiscountsTabs = () => (
    <Table.Tabs>
        <Table.Tab
            id="all_active"
            title="All Active"
            phase="active"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.discount],
                ["is_active", "true"],
                ["ordering", "confirmed,description"],
            ]}
            isDefaultActiveTabForPhase={true}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
        <Table.Tab
            id="review"
            title="Review"
            phase="active"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.discount],
                ["is_active", "true"],
                ["confirmed", "false"],
                ["ordering", "description"],
            ]}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
        <Table.Tab
            id="confirmed"
            title="Confirmed"
            phase="active"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.discount],
                ["is_active", "true"],
                ["confirmed", "true"],
                ["ordering", "description"],
            ]}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
        <Table.Tab
            id="all_inactive"
            title="All Inactive"
            phase="inactive"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.discount],
                ["is_active", "false"],
                ["ordering", "confirmed,description"],
            ]}
            isDefaultActiveTabForPhase={true}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
    </Table.Tabs>
)

export const TaxRatesTabs = () => (
    <Table.Tabs>
        <Table.Tab
            id="all_active"
            title="All Active"
            phase="active"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.tax],
                ["is_active", "true"],
                ["ordering", "confirmed,description"],
            ]}
            isDefaultActiveTabForPhase={true}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
        <Table.Tab
            id="review"
            title="Review"
            phase="active"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.tax],
                ["is_active", "true"],
                ["confirmed", "false"],
                ["ordering", "description"],
            ]}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
        <Table.Tab
            id="confirmed"
            title="Confirmed"
            phase="active"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.tax],
                ["is_active", "true"],
                ["confirmed", "true"],
                ["ordering", "description"],
            ]}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
        <Table.Tab
            id="all_inactive"
            title="All Inactive"
            phase="inactive"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.tax],
                ["is_active", "false"],
                ["ordering", "confirmed,description"],
            ]}
            isDefaultActiveTabForPhase={true}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
    </Table.Tabs>
)
